import { get, set } from 'lodash';

import { Income, StoreEmployment, Asset, Company } from '@funnels/types';
import { FIELD_PATHS } from '@funnels/constants';

export function fixEmployment(income: Income, employments: StoreEmployment[]) {
  // INCOME_EMPLOYMENT_ID still used by SE v1 INCOME_EMPLOYMENT_CLIENT_ID is for SE v2
  const employmentClientId = get(
    { incomes: [income] },
    FIELD_PATHS.INCOME_EMPLOYMENT_CLIENT_ID(0),
    get({ incomes: [income] }, FIELD_PATHS.INCOME_EMPLOYMENT_ID(0))
  );

  // doesn't have an employment
  if (!employmentClientId) {
    //clean up the employment-income link
    set({ incomes: [income] }, FIELD_PATHS.INCOME_EMPLOYMENT_ID(0), undefined);
    return;
  }

  const employment = employments.find((e) => e.clientId === employmentClientId);

  if (!employment || !employment.id) {
    // abort income request if employment create fail
    throw new Error('Incomes create fail');
  }

  const employmentId = employment.id;

  // hydrated incomes have the same value for both id/clientId. It is therefore not necessary to do the mapping.
  // this only applies/fixes (server) id-less incomes who have been created but not hydrated (in the form state).
  set({ incomes: [income] }, FIELD_PATHS.INCOME_EMPLOYMENT_ID(0), employmentId);
}

export function fixRentalIncome(income: Income, assets: Asset[]) {
  const assetClientId = get({ incomes: [income] }, FIELD_PATHS.INCOME_ASSET_ID(0));

  // doesn't have a property
  if (!assetClientId) {
    return;
  }

  const asset = assets.find((a) => a.clientId === assetClientId);

  if (!asset || !asset.id) {
    return;
  }

  const assetId = asset.id;

  // hydrated incomes have the same value for both id/clientId. It is therefore not necessary to do the mapping.
  // this only applies/fixes (server) id-less incomes who have been created but not hydrated (in the form state).
  if (assetId && assetId !== assetClientId) {
    set({ incomes: [income] }, FIELD_PATHS.INCOME_ASSET_ID(0), assetId);
  }
}

export function fixCompany(income: Income, companies: Company[]) {
  const companyClientId = get({ incomes: [income] }, FIELD_PATHS.INCOME_COMPANY_CLIENT_ID(0));

  // doesn't have a property
  if (!companyClientId) {
    //clean up the company-income link
    set({ incomes: [income] }, FIELD_PATHS.INCOME_COMPANY_ID(0), undefined);
    return;
  }

  const company = companies.find((c) => c.clientId === companyClientId);

  if (!company || !company.id) {
    // abort income request if company create fail
    throw new Error('Incomes create fail');
  }
  set({ incomes: [income] }, FIELD_PATHS.INCOME_COMPANY_ID(0), company.id);
}
